import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const AutomaticQuoteError = () => (

  <div className="row">
    <div className="col-md-12">
      <div className="alert alert-warning p-4 my-3 mx-2">
        <h4>
          <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} />
          Sorry, our automatic quote service is temporarily unavailable.
        </h4>
        <p>
          We&apos;re very sorry. We are working diligently to solve the problem.
          Click
          {' '}
          <a href="/custom_quote_request">here</a>
          {' '}
          to submit a custom quote
          and we will contact you within the next 24 hours.
          You could also email us at
          {' '}
          <a href="mailto: support@pentalogix.com">support@pentalogix.com</a>
        </p>
      </div>
    </div>
  </div>
);

export default AutomaticQuoteError;
